import UserAgentProvider from './Provider';
import UserAgent from './UserAgent';
export { UserAgentProvider, UserAgent };